import { InferType } from 'yup';
import * as yup from 'yup';

const HEX8_REGEX = /^#?[0-9a-fA-F]{8}$/;
const colorValidator = (label: string) =>
  yup
    .string()
    .matches(HEX8_REGEX, `${label} must be a valid #AARRGGBB hex color`)
    .required(`${label} is required`);

const optionalColorValidator = (label: string) =>
  yup
    .string()
    .nullable()
    .optional()
    .test(label, `${label} must be a valid #AARRGGBB hex color`, (v) =>
      !v ? true : HEX8_REGEX.test(v),
    );

export const themeFormSchema = yup.object({
  name: yup.string().trim().required('Name is required'),
  order: yup.number().integer().min(0).required('Order is required'),

  scrollerColor: colorValidator('Scroller color'),
  buttonsBackgroundColor: colorValidator('Buttons background color'),
  buttonsIconsColor: colorValidator('Buttons icons color'),
  buttonsActiveIconsColor: optionalColorValidator('Buttons active icons color'),

  gameplayBackgroundColor: optionalColorValidator('Gameplay background color'),
  boardBackgroundColor: optionalColorValidator('Board background color'),

  gameplayBackgroundRepeatMode: yup
    .object({ label: yup.string(), value: yup.string() })
    .nullable()
    .optional(),

  // Image URL fields — populated after upload or from existing doc
  gameplayBackgroundImageUrl: yup.string().nullable().optional(),
  boardBackgroundImageUrl: yup.string().nullable().optional(),
  previewUrl: yup.string().nullable().optional(),
});

export type ThemeFormField = InferType<typeof themeFormSchema>;

export const REPEAT_MODE_OPTIONS = [
  { label: 'Mirror (default)', value: 'mirror' },
  { label: 'Repeat', value: 'repeat' },
];
